import { ApiConstants } from "~/shared/api/api-constants.class";
import $fetch from "~/utils/fetch-utils";
const woosmapEndpoint = ApiConstants.externalEndpoints.woosmap;

type fetchParams = {
  components: string;
  language: string;
  types: string;
};

// this could be extended to support multiple providers
const autocompleteStrategies = {
  woosmap: {
    fetchSuggestion(params: fetchParams, query: string) {
      return $fetch(woosmapEndpoint.autocomplete, {
        searchParams: {
          key: process.env.NEXT_PUBLIC_WOOSMAP_API_KEY!,
          ...params,
          input: query,
        },
      }).json();
    },
    fetchDetails(publicId: string) {
      return $fetch(woosmapEndpoint.details, {
        searchParams: {
          key: process.env.NEXT_PUBLIC_WOOSMAP_API_KEY!,
          public_id: publicId,
        },
      }).json();
    },
  },
};

export default autocompleteStrategies;
